module.exports = __webpack_public_path__ + "img/27.411181ff.jpg";